import FJUploadImageModalContainer from '../FJTextToImage/FJTextToImageLeft/container/FJUploadImageModalContainer';
import FJLoadingModalContainer from './FJLoadingModal/FJLoadingModalContainer';
import FJPreviewModalContainer from './FJPreviewModal/FJPreviewModalContainer';
import FJUpgradeModalContainer from './FJUpgradeModal/FJUpgradeModalContainer';
import FJWarningModalContainer from './FJWarningModal/FJWarningModalContainer';
import FJMobilePreviewModalContainer from './FJMobilePreviewModal/FJMobilePreviewModalContainer';
import FJGlobalLoadingContainer from './FJGlobalLoading/FJGlobalLoadingContainer';
import FJUpgradesTipsContainer from './FJUpgradesTips/FJUpgradesTipsContainer';
import useIsMobile from '../../hooks/useIsMobile';
import FJMobileSimplePreviewModalContainer from './FJMobileSimplePreviewModal/FJMobileSimplePreviewModalContainer';
import FJGuideModalContainer from './FJGuideModal/FJGuideModalContainer';
import FJRecordModalContainer from './FJRecord/container/FJRecordModalContainer.jsx';
import FJRecorderDelayContainer from './FJRecord/container/FJRecorderDelayContainer.jsx';
import FJAddMediaLibraryInfoModalContainer from './FJAddMediaLibraryInfoModal/FJAddMediaLibraryInfoModalContainer.jsx';
import FJAutoSelectionNoticeModalContainer from './FJAutoSelectionNoticeModal/FJAutoSelectionNoticeModalContainer.jsx';

const FJModals = () => {
    const isMobile = useIsMobile();
    const _renderMobileModal = () => {
        if (!isMobile) {
            return null;
        }
        return (
            <>
                <FJMobilePreviewModalContainer />
                <FJMobileSimplePreviewModalContainer />
                <FJAutoSelectionNoticeModalContainer />
            </>
        );
    };
    return (
        // 在 FJModals 中集成
        <>
            <FJWarningModalContainer />
            <FJPreviewModalContainer />
            <FJUpgradeModalContainer />
            <FJUploadImageModalContainer />
            <FJLoadingModalContainer />
            <FJGlobalLoadingContainer />
            <FJUpgradesTipsContainer />
            <FJGuideModalContainer />
            <FJRecordModalContainer />
            <FJRecorderDelayContainer />
            <FJAddMediaLibraryInfoModalContainer />
            {_renderMobileModal()}
        </>
    );
};
export default FJModals;
